export default __webpack_public_path__ + "static/media/img-3.778841e0.webp";